{
	"title": "Transacción no encontrada",
	"description": "Vaya a la descripción general e ingrese un ID de transacción válido. El ID de la transacción se puede encontrar en una declaración o en una factura.",
	"secondaryButtonTitle": "Mostrar página de inicio"
}
